import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { User, UserGroup } from 'src/app/core/models';
import { AlertItem, AlertType } from 'src/app/core/models/AlertItem';
import { AlertService, ModalService, UserGroupService, UserService } from 'src/app/core/services';
import { AdministrativeService } from 'src/app/core/services/administrative.service';
import { BaseModal } from 'src/app/core/utils/BaseModal';

@Component({
  selector: 'app-user-select-modal',
  templateUrl: './user-select-modal.component.html',
  styleUrls: ['./user-select-modal.component.sass']
})
export class UserSelectModalComponent extends BaseModal implements OnInit {

  public loading = false;
  public userGroups: Array<UserGroup>;
  public userGroup: UserGroup;
  public isValid = false;
  public haveRole: boolean;
  public date: any;
  public hours: any;
  public initialState: any;
  modelChanged: Subject<string> = new Subject<string>();
  searchForm: FormGroup;
  checkedUsersForm: any;
  public params;
  public users = [];
  public groupId = null;
  public disableControl = true;
  public promise: Promise<any>;
  public selectedUsersIds: number[] = [];

  constructor(
    public userService: UserService,
    private formBuilder: FormBuilder,
    modalService: ModalService,
    public userGroupService: UserGroupService,
    private alertService: AlertService,
    public administrativeService: AdministrativeService
  ) {
    super(modalService);
    this.modelChanged.pipe(debounceTime(500)).subscribe(() => {
      this.handleSearch();
    });
  }

  async ngOnInit() {
    this.createSearchForm();
    await this.getUsers();
  }

  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      search: ['']
    });
  }

  async handleSearch() {
    this.users = [];
    this.params = this.getFilterParams();
    await this.getUsers(this.params);
  }

  getFilterParams() {
    const search = this.searchForm.get('search').value;
    const filterObj: any = {};
    if (search != null && search !== '') {
      filterObj['email[contains,or]'] = `${search}`;
      filterObj['name[contains,or]'] = `${search}`;
    }
    filterObj.contractsCompany = `[${this.userGroup?.contractId}]`;
    return filterObj;
  }

  async getUsers(params = {}) {
    this.loading = true;
    const response = await this.userService.getAll(params);
    this.users = response;
    this.checkedUsers();
    this.loading = false;
  }

  checkedUsers() {
    if (this.checkedUsersForm == null) {
      this.checkedUsersForm = new FormGroup({});
    }
    if (this.users != null) {
      this.users.forEach((user, i) => {
        if (this.checkedUsersForm[user.id] != null) {
          return;
        }
        const isUserCheked = user.groupIds.indexOf(this.initialState) >= 0;
        this.users[i].checked = isUserCheked;
        this.checkedUsersForm.addControl(
          user.id,
          new FormControl({ value: isUserCheked, disabled: isUserCheked })
        );
      });
      this.checkedUsersForm.valueChanges.subscribe(res => {
        this.isValid = this.checkedUsersForm.valid;
      });
    }
  }

  searchKey(text: string) {
    this.modelChanged.next(text);
  }

  get lastState() {
    return {};
  }

  public async onAllSubmited() {
    this.loading = true;
    const permissionId = this.initialState.permissionId;
    const userIds = Object.entries(this.checkedUsersForm.value)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);

    for (const userId of userIds) {
      await this.administrativeService.addAdminPermissionIntoUser(Number(userId), permissionId);
    };

    this.alertService.show(new AlertItem('AdminPermissionAdded', AlertType.success));
    this.loading = false;
  }
}
